import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { ServiceDetails } from "../../../components/secondaryComponents/SellModeItemsV2";
import { useGetServiceDetails } from "../../../hooks/api/queries";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

export const SMServiceDetails = () => {
  const navigate = useNavigate();
  const { service_id } = useParams();
  const { data: serviceDetails } = useGetServiceDetails(service_id);
  const bookingConfig =
    serviceDetails?.store_service_properties?.[0]?.booking_config;
  const units = { MINUTES: "Mins", HOURS: "Hours", DAYS: "Days" };

  return (
    <RoutedModal
      width={1500}
      isActive={true}
      headerTitle={
        <>
          <span className="d-flex flex-wrap mr-2">
            Select Date & Time{" "}
            <span
              className={`d-flex align-items-center p-0  pr-3 ${globalStyles["statusBlock--pending"]}`}
            >
              <span
                className={`${globalStyles["statusBlock"]} pending white--text mr-3`}
              >
                {serviceDetails?.name}
              </span>
              {bookingConfig?.duration_value}{" "}
              {units?.[bookingConfig?.duration_unit]}
            </span>
          </span>
        </>
      }
      //   headerDescription="Choose your section to manage order"
      closeModal={() => navigate(-1)}
    >
      <ServiceDetails serviceDetails={serviceDetails} />
    </RoutedModal>
  );
};
